/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';

import { Tables } from '@social-solutions/component-library';
import { ITableColumn } from '@social-solutions/component-library/dist/src/src/components/Generics/Table/table.presentation';
import Skeleton from 'react-loading-skeleton';

const loader = {
    name: <Skeleton width='30%' />,
    username: <Skeleton width='30%' />,
    gotoIcon: <Skeleton width='30%' />,
};

export interface IDataService {
    data: any;
    getData(): Array<any>;
    getPaginatedData(start: number, end: number): Array<any>;
    getPageCount(pageSize: number): number;
    updateData(id: string, value: any): void;
}

const TableWithServerPagination = ({
    hidePagination,
    serverData,
    showHeaders,
    pageSizeValues,
    initialStates,
    columns,
    renderRowSubComponent,
}: {
    hidePagination: boolean,
    serverData: IDataService,
    showHeaders: boolean,
    pageSizeValues: number[],
    initialStates: any,
    columns: Array<ITableColumn>,
    renderRowSubComponent?: (rowContainer: { row: any }) => JSX.Element;
}) => {
    const [data, setData] = useState<any[]>(Array(5).fill(loader));
    const [loading, setLoading] = useState(false);
    const [loaded, setLoaded] = useState(false);
    const [pageCount, setPageCount] = useState(0);

    const updateFunction = (dataId: string | number, _rowKey: string, value: any) => {
        const dataIdStr = typeof dataId === 'number' ? dataId.toString() : dataId;
        serverData.updateData(dataIdStr, value);
    };

    const fetchData = React.useCallback(async ({
        pageSize,
        pageIndex,
    }: {
        pageSize: number,
        pageIndex: number
    }) => {

        if (!loaded) {
            setLoading(true);
            setLoading(false);
            setLoaded(true);
        }

        const startRow = pageSize * pageIndex;
        const endRow = startRow + pageSize;
        const curData = serverData.getPaginatedData(startRow, endRow);

        setData(curData);
        setPageCount(serverData.getPageCount(pageSize));

    }, [serverData, loaded]);

    return (
        <Tables.WithServerPagination
            fetchData={fetchData}
            loading={loading}
            pageCount={pageCount}
            data={data}
            columns={columns}
            disablePagination={false}
            initialState={initialStates}
            getRowProps={() => ({
                style: {
                    cursor: 'pointer',
                },
            })}
            hidePagination={hidePagination}
            pageSizeValues={pageSizeValues}
            showHeaders={showHeaders}
            renderRowSubComponent={renderRowSubComponent}
            updateMyData={updateFunction}
        />
    );
};

const TableWithCustomRow: any = TableWithServerPagination.bind({});

export default TableWithCustomRow;